export default {
  ADD: 'green',
  BUY: 'yellow',
  REMOVE: 'red',
  WASTE: 'orange',
  RESOLVE_WASTE: 'blue',
  RESTORE: 'cyan',
  DEFAULT: 'grey',
}
